import { Routes } from '@angular/router'
import { UnsavedChangesGuard } from '@app/shared/services/unsaved-changes.guard'
import { authenticatedGuard, permissionGuard } from '@app/core/auth/guards/auth.guard'
import { AuthCallbackComponent } from '@app/core/auth/components/auth-callback/auth-callback.component'
import { UnauthorizedComponent } from '@app/core/auth/components/unauthorized/unauthorized.component'
import { ContentUnitComponent } from '@features/content-unit/content-unit.component'
import { TemplateComponent } from '@features/template/template.component'
import { InsuredComponent } from '@features/insured/insured.component'
import { LandingPageComponent } from '@features/landing-page/landing-page.component'
import { CertificateHolderComponent } from '@features/certificate-holder/certificate-holder.component'
import { CertificateComponent } from '@features/certificate/certificate.component'
import { CertificatePreviewComponent } from '@features/certificate-preview/certificate-preview.component'

export const routes: Routes = [
  {
    path: 'admin',
    component: InsuredComponent,
    title: 'Administration',
    canActivate: [authenticatedGuard, permissionGuard('ALB_ALBERT_ADMIN')]
  },
  {
    path: 'auth/callback',
    component: AuthCallbackComponent,
    title: 'Authenticating...'
  },
  {
    path: 'certificate/create',
    component: CertificateComponent,
    title: 'Create New Certificate',
    canActivate: [authenticatedGuard],
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'certificate/:uuid',
    component: CertificateComponent,
    title: 'Detailview Certificate',
    canActivate: [authenticatedGuard],
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'certificate/:uuid/preview',
    component: CertificatePreviewComponent,
    title: 'Certificate Preview',
    canActivate: [authenticatedGuard],
    data: { withoutLayout: true }
  },
  {
    path: 'certificate-holder',
    title: 'Certificate Holder Management',
    component: CertificateHolderComponent,
    canActivate: [permissionGuard('ALB_ALBERT_E_')],
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'certificate-holder/create',
    component: CertificateHolderComponent,
    title: 'Create New Certificate Holder',
    canActivate: [permissionGuard('ALB_ALBERT_E_')],
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'certificate-holder/:uuid',
    component: CertificateHolderComponent,
    title: 'Detailview Certificate Holder',
    canActivate: [permissionGuard('ALB_ALBERT_E_')],
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'content-unit',
    title: 'ContentUnit Management',
    component: ContentUnitComponent,
    canActivate: [permissionGuard('ALB_ALBERT_REDACT_')],
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'content-unit/create',
    component: ContentUnitComponent,
    title: 'Create New Content Unit',
    canActivate: [permissionGuard('ALB_ALBERT_REDACT_')],
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'content-unit/:uuid',
    component: ContentUnitComponent,
    title: 'Detailview ContentUnit',
    canActivate: [permissionGuard('ALB_ALBERT_REDACT_')],
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'insured/create',
    component: InsuredComponent,
    title: 'Create New Insured',
    canActivate: [authenticatedGuard],
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'insured/:uuid',
    component: InsuredComponent,
    title: 'Detailview Insured',
    canActivate: [authenticatedGuard],
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'template',
    title: 'Template Management',
    component: TemplateComponent,
    canActivate: [permissionGuard('ALB_ALBERT_REDACT_')],
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'template/create',
    component: TemplateComponent,
    title: 'Create New Template',
    canActivate: [permissionGuard('ALB_ALBERT_REDACT_')],
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'template/:uuid',
    component: TemplateComponent,
    title: 'Detailansicht Template',
    canActivate: [permissionGuard('ALB_ALBERT_REDACT_')],
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
    title: 'Unauthorized'
  },
  {
    path: '',
    component: LandingPageComponent,
    title: 'Albatros Certificate Manager',
    canActivate: [authenticatedGuard]
  },
  { path: '**', redirectTo: '' }
]
